import React, { Component } from 'react';
import styled from 'styled-components';
import withConfig from '../../../context/withConfig';
import renderAttachment from './renderAttachment';
import MessageContainer from './MessageContainer';
import Grow from './Grow';

const SectionsContainer = styled.div`
  min-width: 0;
  position: relative;
  margin-left: 20px;
`;

const TextTipsContainer = styled.div`
  background-color: #000000;
  opacity: 0.4;
  text-align: center;
  padding: 5px;
  border-radius: 20px;
`;

const TextTips = styled.div`
  color: white;
`;

class Attachment extends Component {
  render() {
    const {
      activity,
      config: { imageWidth, enableClickToOpen }
    } = this.props;
    const attachment = renderAttachment(activity, 0);
    const width =
      imageWidth &&
      !!(
        activity.attachments &&
        activity.attachments.length &&
        activity.attachments[0] &&
        activity.attachments[0].contentType &&
        activity.attachments[0].contentType.includes('image')
      )
        ? imageWidth
        : '100%';
    return (
      <MessageContainer imageWidth={width}>
        {/* <BotAvatar
          visible={blockPosition === 'end' || blockPosition === 'single'}
          data-test-id="botAvatar"
          inOperatorConversation={checkIsInOperatorConversation(activity)}
        /> */}
        <SectionsContainer data-test-id="sectionsContainer">
          {attachment.sections}
          {enableClickToOpen &&
            attachment.sections &&
            attachment.sections[0] &&
            attachment.sections[0].key === 'image' && (
              <TextTipsContainer>
                <TextTips>Click to open in a new tab</TextTips>
              </TextTipsContainer>
            )}
        </SectionsContainer>
        <Grow fullWidthSection={attachment.fullWidth} />
      </MessageContainer>
    );
  }
}

export default withConfig(Attachment);



// WEBPACK FOOTER //
// ./src/components/MessageHistory/BotMessage/Attachment.js